import { useLocalStorage } from "@vueuse/core";
import { defaultsDeep } from "lodash";
import { toRefs } from "@vueuse/core";

const AvailableLocales = [
  {
    title: "Français",
    code: "fr",
    country: "fr"
  },
  {
    title: "العربية",
    code: "ar",
    country: "dz"
  },
  {
    title: "English",
    code: "en",
    country: "us"
  }
];

const UserStorage = useLocalStorage(
  "user-state-v1",
  {
    token: null,
    user: null,
    locale: "fr",
    dark: false
  },
  {
    deep: true
  }
);

export function useUserState() {
  function logout() {
    UserStorage.value.token = null;
    UserStorage.value.user = null;
  }

  UserStorage.value = defaultsDeep({}, UserStorage.value, {
    token: null,
    user: null,
    locale: "fr",
    dark: false
  });

  return {
    ...toRefs(UserStorage),
    logout,
    availableLocales: AvailableLocales
  };
}
